import {
  AdjustmentsHorizontalIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';
import {
  AdjustmentsHorizontalIcon as SolidAdjustmentsHorizontalIcon,
  EnvelopeIcon as SolidEnvelopeIcon,
} from '@heroicons/react/24/solid';
import React, { useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';

import PlugIcon from 'assets/PlugIcon';
import CollapsibleSidebar from 'components/CollapsibleSidebar/CollapsibleSidebar';
import SidebarNavigationLink from 'components/CollapsibleSidebar/SidebarNavigationLink';
import ContentContainer from 'components/ContentContainer/ContentContainer';
import { t } from 'locales/i18n';
import { AssessmentDetailsContext } from 'providers/AssessmentDetailsProvider';

const Settings = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { isPractice } = useContext(AssessmentDetailsContext);

  return (
    <>
      <CollapsibleSidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      >
        <SidebarNavigationLink
          description={t('General')}
          to="general"
          icon={<AdjustmentsHorizontalIcon />}
          activeIcon={<SolidAdjustmentsHorizontalIcon />}
          isCollapsed={!isSidebarOpen}
          isShowing
        />
        <SidebarNavigationLink
          description={t('Email')}
          to="email"
          icon={<EnvelopeIcon />}
          activeIcon={<SolidEnvelopeIcon />}
          isCollapsed={!isSidebarOpen}
          isShowing
        />
        {!isPractice && (
          <SidebarNavigationLink
            description={t('Integrations')}
            to="integrations"
            icon={<PlugIcon />}
            activeIcon={<PlugIcon />}
            isCollapsed={!isSidebarOpen}
            isShowing
          />
        )}
      </CollapsibleSidebar>
      <ContentContainer>
        <Outlet />
      </ContentContainer>
    </>
  );
};

export default Settings;
